module.exports = __webpack_public_path__ + "static/Streetview-0c83adc0690f2e8adbe90d47480d1c66.jpg";